import { render, staticRenderFns } from "./VaccinationSetList.vue?vue&type=template&id=ff0eb234&scoped=true&"
import script from "./VaccinationSetList.vue?vue&type=script&lang=js&"
export * from "./VaccinationSetList.vue?vue&type=script&lang=js&"
import style0 from "./VaccinationSetList.vue?vue&type=style&index=0&id=ff0eb234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0eb234",
  null
  
)

export default component.exports